﻿import React from 'react';
import PropTypes from 'prop-types';
import { Collapse, Icon } from "@blueprintjs/core";
import './Layout.css';
import { ShowHide } from './ShowHide';
import classNames from 'classnames';

export function Collapsable(
    {
        loading = false,
        disabled = false,
        title = '',
        fullWidth = false,
        expanded = false,
        metadata = '',
        lightMode = false,
        className = '',
        children,
        headerButtons,
        onClick
    }
) {

    return (
        <div className={classNames("collapsable-item", { "full-width": fullWidth })}>
            <div className={classNames({ "bp6-skeleton": loading, "collapsable-header": !lightMode, "collapsable-header-lightMode": lightMode }, className)} onClick={onClick} onKeyDown={() => { }} role="switch" tabIndex={0} aria-checked={expanded}>
                <div className="collapsable-title">
                    {title}
                </div>

                <div className="collapsable-icons button-row">
                    <span className="collapsable-metadata">
                        {metadata}
                    </span>
                    <ShowHide
                        evaluator={!disabled}
                        show={headerButtons}
                    />
                    <Icon className="collapsable-icon-status" icon={expanded ? "chevron-up" : "chevron-down"} />
                </div>
            </div>
            <Collapse isOpen={expanded}>
                <ShowHide
                    evaluator={lightMode}
                    show={<div className="collapsable-content-lightMode">{children}</div>}
                    hide={children}
                />
            </Collapse>
        </div>
    );
}

Collapsable.propTypes = {
    loading: PropTypes.bool,
    disabled: PropTypes.bool,
    title: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
    headerButtons: PropTypes.node,
    fullWidth: PropTypes.bool,
    children: PropTypes.node,
    expanded: PropTypes.bool,
    lightMode: PropTypes.bool,
    metadata: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
    onClick: PropTypes.func.isRequired,
    className: PropTypes.string
};